import { get, includes, isArray } from 'lodash-es'
import i18nVue from '@/i18n/locale'

const INVALID_REASON = {
  // 商机无效原因
  DUPLICATE: 7, // 重复门店
  ELSE: 999, // 其他原因
}
export default {
  required(mask = '', { gettext }, payload) {
    return {
      messages: { required: `${mask} ${gettext('不能为空')}` },
      rules: { required: true },
    }
  },

  max(mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      messages: { max: `${mask}${sprintf(gettext('不能超过%d'), max)}` },
      rules: { max: +max, type: 'number' },
    }
  },

  min(mask = '', { gettext, sprintf }, payload) {
    const [min] = payload
    return {
      messages: { min: `${mask}${sprintf(gettext('不小于%d'), min)}` },
      rules: { min: +min, type: 'number' },
    }
  },

  maxLength(mask = '', { gettext, sprintf }, payload) {
    const [length] = payload
    return {
      messages: { max: `${mask}${sprintf(gettext('不能超过%d字'), length)}` },
      rules: { max: +length },
    }
  },

  requireLength(mask = '', { gettext, sprintf }, payload) {
    const [length] = payload
    return {
      messages: { len: `${mask}${sprintf(gettext('必须为%d字'), length)}` },
      rules: {
        len: length,
      },
    }
  },

  requireMultyLength(mask = '', { gettext, sprintf }, payload) {
    const [length1, length2] = payload
    return {
      messages: { custom: `${mask}${sprintf(gettext('必须为%d或%d字'), length1, length2)}` },
      rules: {
        custom: value => {
          const length = value.trim().length
          if (length === length1 || length === length2) {
            return true
          } else {
            return false
          }
        },
      },
    }
  },

  multiplePhones(mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      rules: {
        custom: value => (value && max ? value.split(',').length <= max : true),
        pattern: /^[0-9,]+$/,
      },
      messages: {
        custom: max ? `${mask}${sprintf(gettext('最多%d个'), max)}` : '',
        pattern: gettext('电话支持字符：数字、英文逗号，录入其他符号，不允许提交'),
      },
    }
  },

  // 结构化多个电话
  structuredPhones(mask = '', { gettext, sprintf }, payload) {
    const validator = function (value) {
      for (const i of value) {
        if (!/^[0-9]{10}$/.test(i.value)) {
          return false
        }
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: gettext('手机和座机都只支持10位数字'),
      },
    }
  },

  postCode(mask = '', { gettext }, payload) {
    return {
      rules: {
        pattern: /^\d+$/,
        custom: value => value.length === 5,
      },
      messages: {
        pattern: `${mask}${gettext('仅支持数字输入')}`,
        custom: gettext('请输入5位有效数字'),
      },
    }
  },

  phone(mask = '', { gettext }, payload) {
    return {
      messages: {
        pattern: `${mask}${gettext('仅支持数字输入')}`,

        // pattern: `${mask}${gettext('首位必须是1')}`
        // custom: `${mask}${gettext('输入有误')}`
      },
      rules: {
        // custom: value => (value ? value.length : true),
        // pattern: /^1\d{10}$/
        pattern: /^\d+$/,
      },
    }
  },
  kpPhoneMX(mask = '', { gettext }, payload) {
    const validator = function (value) {
      const reg = /^(1\d{10}|\d{10})$/g
      if (!reg.test(value)) {
        return false
      }
      return true
    }
    return {
      messages: {
        custom: `${mask}${i18nVue.t('FoodB_Website_tNXH_hTaL' /** 请输入正确的手机号 */)}`,
      },
      rules: {
        custom: validator,
      },
    }
  },

  telePhone(mask = '', { gettext }, payload) {
    return {
      messages: {
        // pattern: `${mask}${gettext('仅支持数字输入')}`
        pattern: `${mask} ${gettext('首位必须是1，必须输入11位')}`,
        // custom: `${mask}${gettext('输入有误')}`
      },
      rules: {
        // custom: value => (value ? value.length : true),
        pattern: /^1\d{10}$/,
        // pattern: /^\d+$/
      },
    }
  },

  email(mask = '', { gettext }, payload) {
    return {
      rules: {
        // 和后端规则保持一致
        pattern: /^[^@]+@[^@]+$/i,
        // type: 'email'
      },
      messages: {
        pattern: gettext('请输入正确的邮箱地址'),
      },
    }
  },

  number(mask = '', { gettext }, payload) {
    return {
      rules: {
        type: 'number',
      },
      messages: {
        type: gettext('请输入数字'),
      },
    }
  },
  cardNumber(mask = '', { gettext }, payload) {
    return {
      rules: {
        type: 'number',
        len: 18,
      },
      messages: {
        type: gettext('银行卡号仅支持数字输入'),
        len: gettext('银行卡号必须为18位'),
      },
    }
  },

  specialChars(mask = '', { gettext }, payload) {
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          return !/[\!\"\#\$\%\/\(\)\=\?\¡\¨\*\[\]\;\:\_\¿\´\+\{\}\,\.\-\>\<\°\|\@\¬\\\~\`\^\ñ\Ñ\á\é\í\ó\ú\Á\É\Í\Ó\Ú\â\ê\î\ô\û\Â\Ê\Î\Ô\Û\ä\ë\ï\ö\ü\Ä\Ë\Ï\Ö\Ü]+/.test(
            value,
          )
        },
      },
      messages: {
        custom: gettext('不允许特殊字符'),
      },
    }
  },
  specialCharsMX(mask = '', { gettext }, payload) {
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          return !/[\!\"\#\$\%\/\(\)\=\?\¡\¨\*\[\]\;\:\_\¿\´\+\{\}\,\-\>\<\°\|\@\¬\\\~\`\^\á\é\í\ó\ú\Á\É\Í\Ó\Ú\â\ê\î\ô\û\Â\Ê\Î\Ô\Û\ä\ë\ï\ö\ü\Ä\Ë\Ï\Ö\Ü]+/.test(
            value,
          )
        },
      },
      messages: {
        custom: gettext('不允许特殊字符'),
      },
    }
  },
  taxIdcifRules(mask = '', { gettext }) {
    const validator = function (value) {
      if (!/^\d{11}$/g.test(value)) {
        return false
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: i18nVue.t('FoodB_collection_11_digits_QhYs' /** 11位数字，不能有空格 */),
      },
    }
  },
  taxIdRules(mask = '', { gettext }) {
    const validator = function (value) {
      if (!/^([A-Z]|\d){12,13}$/.test(value)) {
        return false
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: i18nVue.t('FoodB_collection_12_or_woYo' /** 输入12-13数字或者字母 */),
      },
    }
  },
  postCodeRules(mask = '', { gettext }) {
    const validator = function (value) {
      if (!/^\d{5,6}$/g.test(value)) {
        return false
      }
      return true
    }
    return {
      rules: {
        custom: validator,
      },
      messages: {
        custom: i18nVue.t('FoodB_collection_5_6_hFrc' /** 5-6位数字 */),
      },
    }
  },
  curpRules(mask = '', { gettext }) {
    return {
      rules: {
        len: 18,
        custom: value => (value ? value.toLocaleUpperCase() === value : true),
      },
      messages: {
        custom: gettext('Curp号必须为大写字母'),
        len: gettext('Curp号必须为18位字符'),
      },
    }
  },
  decimal(mask, { gettext, sprintf }, payload) {
    const [len] = payload
    return {
      rules: {
        type: 'number',
        custom: value => {
          let decimal = (value + '').split('.')[1]
          return decimal ? decimal.length <= len : true
        },
      },
      messages: {
        custom: sprintf(mask + gettext('数值只能是%s位小数'), len),
      },
    }
  },

  openInfo(mask = '', { gettext }, payload) {
    const [tip1] = payload
    return {
      rules: {
        custom: value => {
          if (!value) return true
          /* eslint-disable */
          return value.isNeedPad !== 0 && value.bizDayTime.length > 0
        },
      },
      messages: {
        custom: `${mask}/${tip1}${gettext('不能为空')}`,
      },
    }
  },
  priceInfo(mask = '', { gettext }, payload) {
    return {
      rules: {
        custom: value => {
          if (value.customerPriceRange) {
            return true
          } else {
            return false
          }
        },
      },
      messages: {
        custom: `${mask}${gettext('不能为空')}`,
      },
    }
  },
  cost(mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      rules: {
        type: 'number',
        custom: value => {
          return value ? value <= max : true
        },
      },
      messages: {
        custom: sprintf(mask + gettext('不能超过%d'), max),
      },
    }
  },
  shopId(mask = '', { gettext, sprintf }, payload) {
    return {
      rules: {
        custom: value => {
          return true
        },
        customRequired: value => {
          if (!value) {
            return false
          }
          if (!get(value, 'list.length', null)) {
            return false
          }
          return true
        },
        repeatShopId: value => {
          if (includes(value.list, INVALID_REASON.DUPLICATE) && !value.repeatShopId) {
            return false
          }
          if (
            includes(value.list, INVALID_REASON.DUPLICATE) &&
            !/^[0-9]+$/.test(value.repeatShopId)
          ) {
            return false
          }
          return true
        },
      },
      messages: {
        custom: gettext('您提交的无效原因有误，请检查'),
        customRequired: `${mask}${gettext('不能为空')}`,
      },
    }
  },
  requireValue(mask = '', { gettext }, payload) {
    const [requireValue] = payload
    return {
      rules: {
        custom: value => {
          return value === requireValue
        },
      },
      messages: {
        custom: `${mask}${gettext('需要完善')}`,
      },
    }
  },
  shopIdCascade(mask = '', { gettext }) {
    return {
      rules: {
        custom: value => {
          return !!value
        },
        repeatShopId: value => {
          return !!/^[0-9]+$/.test(value)
        },
      },
      messages: {
        custom: `${mask}${gettext('不能为空')}`,
        repeatShopId: gettext('请输入有效的门店id'),
      },
    }
  },
  checkAtLastOne(mask = '', payload) {
    let { checkKeys } = payload
    return {
      rules: {
        custom: valueMap => {
          let status = false
          checkKeys.forEach(key => {
            let val = valueMap[key]
            !status && (status = !!(isArray(val) ? val.length : val))
          })
          return status
        },
      },
      messages: {
        custom: mask,
      },
    }
  },
  regexp(mask = '', payload) {
    let { checkKeys = ['other'], regexp } = payload
    return {
      rules: {
        custom: valueMap => {
          let status = true
          checkKeys.forEach(key => {
            let val = valueMap[key]
            let strRegexp = regexp.substring(1)
            strRegexp = strRegexp.substring(0, strRegexp.length - 1)
            status && (status = !!new RegExp(strRegexp).test(val))
          })
          return status
        },
      },
      messages: {
        custom: mask,
      },
    }
  },
}
